import { get, isNaN } from 'lodash';
import { change, startAsyncValidation } from 'redux-form';
import { ATTENDEE_PRICING_FORM } from '../constants';
import update from 'immutability-helper';

export const onChangeAttendeeForm = (e, fields, value, index, dispatch) => {
  const allTiers = fields.getAll();
  let updatedTiers = update(allTiers, { [index]: { $merge: value } });
  const key = Object.keys(value)[0];

  if ('min' === key) {
    // if user changes max input change the previous row's max value
    const min = parseInt(get(value, 'min'), 10);
    updatedTiers = update(allTiers, {
      [index - 1]: { $merge: { max: !isNaN(min) ? min - 1 : null } },
      [index]: { $merge: value }
    });
  }
  dispatch(startAsyncValidation(ATTENDEE_PRICING_FORM));
  dispatch(change(ATTENDEE_PRICING_FORM, 'tiers', updatedTiers));
};

export const onChangeAddAttendeeRow = (e, fields, dispatch) => {
  e.preventDefault();
  const tiersLength = fields.length;
  const allTiers = fields.getAll();
  const attendeeNumber = get(allTiers, [tiersLength - 1, 'max'], null);
  const updatedTiers = update(allTiers, {
    $push: [{ max: attendeeNumber }],
    [tiersLength - 1]: { $merge: { max: null } }
  });

  dispatch(change(ATTENDEE_PRICING_FORM, 'tiers', updatedTiers));
};

export const onChangeDeleteAttendeeRow = (e, fields, index, dispatch) => {
  e.preventDefault();
  const allTiers = fields.getAll();
  const attendeeNumber = get(allTiers, [index, 'max'], null);
  const updatedTiers = update(allTiers, {
    $splice: [[index, 1]],
    [index - 1]: { $merge: { max: attendeeNumber } }
  });
  dispatch(change(ATTENDEE_PRICING_FORM, 'tiers', updatedTiers));
};

export const onChangeNumberGuests = (e, value, attendeeTiers, dispatch) => {
  const tiersLength = attendeeTiers.length;
  const updatedTiers = update(attendeeTiers, {
    [tiersLength - 1]: { $merge: { max: value } }
  });

  dispatch(change(ATTENDEE_PRICING_FORM, 'number_guests', value));
  dispatch(change(ATTENDEE_PRICING_FORM, 'tiers', updatedTiers));
};
